import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaChevronDown } from 'react-icons/fa';
import './FAQ.css';

const faqData = [
  {
    question: "What types of construction projects do you handle?",
    answer: "We handle a wide range of projects, including luxury villas, residential houses, commercial buildings, corporate offices, and renovation projects across Madurai and Tamil Nadu."
  },
  {
    question: "Do you provide architectural design services?",
    answer: "Yes, we have a team of modern house architects and civil engineers who provide comprehensive planning, structural design, and architectural services tailored to your needs."
  },
  {
    question: "How do you ensure the quality of construction materials?",
    answer: "We use only premium, industry-standard materials. Our multi-stage inspection process ensures that all materials meet high durability and safety standards before and during construction."
  },
  {
    question: "Do you handle building approvals and legal permits?",
    answer: "Absolutely. We manage the entire legal process, including obtaining building approvals, permits, and compliance with local municipal authority regulations in Madurai and other districts."
  },
  {
    question: "What is your typical project timeline?",
    answer: "Timelines vary depending on the scale and complexity of the project. However, we pride ourselves on on-time delivery through detailed project management and structured timelines."
  }
];

const FAQItem = ({ question, answer, isOpen, toggle }) => {
  return (
    <div className={`faq-item ${isOpen ? 'open' : ''}`}>
      <button className="faq-question" onClick={toggle}>
        <span>{question}</span>
        <motion.div
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.3 }}
        >
          <FaChevronDown />
        </motion.div>
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
            className="faq-answer-wrapper"
          >
            <div className="faq-answer">
              <p>{answer}</p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const FAQ = () => {
  const [openIndex, setOpenIndex] = React.useState(0);

  return (
    <section className="faq-section" id="faq">
      <div className="container">
        <div className="section-header" data-aos="fade-up">
          <span className="subtitle">Got Questions?</span>
          <h2>Frequently Asked <span>Questions</span></h2>
          <p>Find answers to common questions about our construction services and process.</p>
        </div>
        <div className="faq-list">
          {faqData.map((item, index) => (
            <FAQItem
              key={index}
              question={item.question}
              answer={item.answer}
              isOpen={openIndex === index}
              toggle={() => setOpenIndex(openIndex === index ? -1 : index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
